var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6569 13.6569C10.5327 16.781 5.46734 16.781 2.34315 13.6569C-0.781048 10.5327 -0.781049 5.46734 2.34315 2.34315C5.46734 -0.781049 10.5327 -0.781049 13.6569 2.34315C16.781 5.46734 16.781 10.5327 13.6569 13.6569ZM10.687 5.31299C10.9213 5.54731 10.9213 5.92721 10.687 6.16152L8.84853 8L10.687 9.83848C10.9213 10.0728 10.9213 10.4527 10.687 10.687C10.4527 10.9213 10.0728 10.9213 9.83848 10.687L8 8.84853L6.16152 10.687C5.92721 10.9213 5.54731 10.9213 5.31299 10.687C5.07868 10.4527 5.07868 10.0728 5.31299 9.83848L7.15147 8L5.31299 6.16152C5.07868 5.92721 5.07868 5.54731 5.31299 5.31299C5.54731 5.07868 5.92721 5.07868 6.16152 5.31299L8 7.15147L9.83848 5.31299C10.0728 5.07868 10.4527 5.07868 10.687 5.31299Z",
    fill: "#C9C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCloseIcon);
export default __webpack_public_path__ + "static/media/input_close_icon.c4c51ace36d7799b93392a1b4675f2c7.svg";
export { ForwardRef as ReactComponent };